module.exports = __webpack_public_path__ + "img/2004.97844aac.jpg";